export const notificationInfoFragment = `
id
notificationType
organizationId
priority
text
url
`;
